import React, { useState, useEffect } from 'react';
import { MDBIcon, MDBInput, MDBBtn, MDBBtnGroup } from 'mdb-react-ui-kit';
import { FormControl, FormLabel, Select, InputGroup, InputRightAddon, Box, Text, Flex } from '@chakra-ui/react';

export default function Price({ onPriceSelect, onUnitPriceSelect, category, initialUnit }) {
  const [price, setPrice] = useState('');
  const [priceUnit, setPriceUnit] = useState(initialUnit || 'kg');
  
  useEffect(() => {
    if (initialUnit) {
      setPriceUnit(initialUnit);
    }
  }, [initialUnit]);
  
  const handleInputChange = (event) => {
    const value = event.target.value;
    setPrice(value);
    onPriceSelect(value);
  };
  
  const handleUnitChange = (event) => {
    const unit = event.target.value;
    setPriceUnit(unit);
    if (onUnitPriceSelect) {
      onUnitPriceSelect(unit);
    }
  };
  
  // Get unit options based on category
  const getUnitOptions = () => {
    if (category === "Grains" || category === "Vegetables" || category === "Spices") {
      return [
        { value: "kg", label: "per Kilogram (kg)" },
        { value: "g", label: "per Gram (g)" },
        { value: "quintal", label: "per Quintal" },
        { value: "ton", label: "per Ton" }
      ];
    } else if (category === "Fruits") {
      return [
        { value: "kg", label: "per Kilogram (kg)" },
        { value: "g", label: "per Gram (g)" },
        { value: "dozen", label: "per Dozen" },
        { value: "piece", label: "per Piece" }
      ];
    } else if (category === "Dairy") {
      return [
        { value: "liter", label: "per Liter" },
        { value: "kg", label: "per Kilogram (kg)" },
        { value: "piece", label: "per Piece" }
      ];
    } else if (category === "Livestock") {
      return [
        { value: "piece", label: "per Piece" },
        { value: "pair", label: "per Pair" }
      ];
    }
    
    // Default units
    return [
      { value: "kg", label: "per Kilogram (kg)" },
      { value: "g", label: "per Gram (g)" },
      { value: "quintal", label: "per Quintal" },
      { value: "ton", label: "per Ton" },
      { value: "dozen", label: "per Dozen" },
      { value: "piece", label: "per Piece" },
      { value: "liter", label: "per Liter" }
    ];
  };

  return (
    <Box mt={3} mb={4}>
      <FormLabel fontWeight="bold" mb={2}>Price Details*</FormLabel>
      
      <Flex direction={{ base: "column", md: "row" }} gap={4}>
        <FormControl>
          <FormLabel fontSize="sm">Price Amount</FormLabel>
          <InputGroup>
            <div style={{
              border: '1px solid #CBD5E0',
              borderRight: 'none',
              borderRadius: '5px 0 0 5px',
              padding: '10px',
              display: 'flex',
              alignItems: 'center',
              backgroundColor: '#f8f9fa'
            }}>
              <MDBIcon fas icon="rupee-sign" />
            </div>
            <MDBInput 
              label='Enter Price*' 
              id='typeNumber' 
              type='number' 
              value={price}
              onChange={handleInputChange} 
            />
          </InputGroup>
        </FormControl>
        
        <FormControl>
          <FormLabel fontSize="sm">Price Per Unit</FormLabel>
          <Select 
            value={priceUnit}
            onChange={handleUnitChange}
            bg="white"
            borderColor="#CBD5E0"
          >
            {getUnitOptions().map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Select>
        </FormControl>
      </Flex>
      
      <Text fontSize="sm" color="gray.500" mt={2}>
        The price you enter will be displayed as ₹{price || '0'}/{priceUnit}
      </Text>
    </Box> 
  );
}